<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="leads-conversions-template" v-else-if="loaded" > 
        
        <spinner v-if="!dataLoaded" ></spinner>
        
        <div class="template-padding" v-else-if="dataLoaded" >
            <orders  :data="rows" page="conversions"  ></orders>
        </div>

    </div>
</template>

<script>    
import Cookies from 'js-cookie'
import modal from '@/components/modal.vue'  
import orders from '@/components/orders.vue'  
import helper from '@/helpers/helpers.js';
    
export default{
    name: "LeadConversions",
    props: {
        passed_organizationID: { 
            type: [String],
        }
    },
    components:{
        modal,
        orders
    },
    data () {
        return {
            filter: '',
            columns: [
                {
                    label: 'EMAIL',
                    field: 'email',
                    //field: this.LeadEmail,
                    html:true,
                    tdClass: 'font-800',
                    thClass: 'font-800',
                    //width: '350px',
                },
                {
                    label: 'PHONE',
                    field: 'phone',
                    hidden: true,
                    //field: this.returnName,
                },
                {
                    label: 'FIRST SOURCE',
                    //field: this.returnFirstSource,
                    field: 'firstTouch',
                    //formatFn: this.renderTag,
                    //width: '450px',
                },
                {
                    label: 'LAST SOURCE',
                    //field: this.returnLastSource,
                    field: 'lastTouch',
                    //formatFn: this.renderTag,
                    //width: '550px',
                },
                {
                    label: 'CONVERSION NAME',
                    field: 'name',
                    //field: this.returnName,
                    //width: '350px',
                },
                {
                    label: 'PRICE',
                    field: 'price',
                    type: 'number',
                    tdClass: 'text-right narrow-w',
                    thClass: 'text-right narrow-w',
                    //field: this.returnName,
                    //width: '150px',
                },
                {
                    label: 'STATUS',
                    field: 'status',
                    //field: this.returnName,
                    //type: 'number',
                    tdClass: 'text-right narrow-w',
                    thClass: 'text-right narrow-w',
                    //width: '150px',
                },
                {
                    label: 'CREATED',
                    field: this.returnDate,
                    tdClass: 'text-right narrow-w',
                    thClass: 'text-right narrow-w',
                    //width: '150px',
                },
            ],
            storedRows: [],
            rows: [],
            loaded: false,
            dataLoaded: false,
            modalData: null,
            modalState: false,
            paginationOptions:{ 
                enabled: true,
                perPage: 20,
                perPageDropdown: [50, 100],
                dropdownAllowAll: true,
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Leads per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
                perPageDropdownEnabled: false,
            },
            currentPage: 1,
            ID: null
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
    },
    mounted: function(){
        
        //this.get_data();
        this.loaded = true;
        this.dataLoaded = true;
        
    },
    computed: {
    },
    methods: {
        get_data( startAtDoc = null, endBefore = null, loadSpinner = true ){
            
            if( loadSpinner ){
                this.dataLoaded = false
            }
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passed_organizationID )
            
            const db = this.$firebase.firestore();
            
            //var ref = db.collection('organizations/'+orgID+'/leads').where('email', '>', '' )
            //var ref = db.collection('organizations/'+orgID+'/leads').where('filter.email_salt', '==', true ).orderBy('filter.datetime', 'desc').limit(50)
            
            if( endBefore == null && startAtDoc == null ){
                var ref = db.collection('organizations/'+orgID+'/orders').orderBy('datetime', 'desc').limit(40)
            }else if( startAtDoc == null && endBefore != null ){
                var ref = db.collection('organizations/'+orgID+'/orders').orderBy('datetime', 'desc').endBefore( endBefore )
            }else if( startAtDoc != null && endBefore == null ){
                var ref = db.collection('organizations/'+orgID+'/orders').orderBy('datetime', 'desc').startAfter( startAtDoc ).limit(20)
            }
            
            return ref.get()
                .then((snapshot) => {
                    let results = this.rows;
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                /*
                                var subcollection = this.getSubcollectionDocs(doc.id);
                                return subcollection.then((docs) => {              
                                    item.tags_subcollection = docs;
                                    results.push(item);     
                                    //console.log( item )
                                    
                                    this.rows = results
                                    
                                    
                                    return results;      
                                });
                                */
                                if( item.email != "" ){
                                    results.push(item);  
                                }
                                   
                                console.log( item )

                                results.sort((a, b) => b.datetime - a.datetime);
                            
                                this.rows = results
                                this.storedRows = results

                                return results; 
                                
                        })
                        
                    )
                    .then(results => {                        
                        //console.log(results)
                        this.loaded = true;
                        this.dataLoaded = true;
                        this.paginationOptions.setCurrentPage = this.currentPage
                        return results;   
                        //return results.length > 0 ? results[results.length - 1] : [];
                        
                    })
                
                })
            
        },
        
        get_new_data(){
            
            let last = this.storedRows[0]
            //console.log(last)
            this.currentPage = 1
            this.get_data( null, last.datetime )
            
        },
        
        load_more( ){
            
            console.log( "load more documents" )
            let startAt = this.rows[ this.rows.length - 1 ]
            console.log( "start with: "+ startAt.email )
            this.get_data( startAt.datetime, null )
            
        },
        
        onPageChange( params ){
            
            //console.log( params )
            
            this.currentPage = params.currentPage;
            
            if( params.currentPage >= params.total ){
                //console.log( "load more documents" )
                let startAt = this.rows[ this.rows.length - 1 ]
                //console.log( "start with: "+ startAt.email )
                this.get_data( startAt.datetime, null, false )
            }

        },
        
        searchFirestore( field, value ){
            
            this.dataLoaded = false

            //this.storedRows = this.rows
            //console.log( this.storedRows )
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passed_organizationID )
            const db = this.$firebase.firestore();

            if( field == 'tags' ){
                if( value.split(" ").length == 0 ){
                    var ref = db.collection('organizations/'+orgID+'/orders').where( 'email', '>', '' ).where("tags", 'array-contains', value)
                }else{
                    var ref = db.collection('organizations/'+orgID+'/orders').where( 'email', '>', '' ).where("tags", 'array-contains-any', value.split(" ") )
                }
            }else{
                var ref = db.collection('organizations/'+orgID+'/orders').where(field, '>=', value).where(field, '<=', value+ '\uf8ff')
            }
            

            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                            
                                results.push(item);     
                                //console.log( item )

                                results.sort((a, b) => b.datetime - a.datetime);
                            
                                this.rows = results


                                return results; 
                                
                        })
                        
                    )
                    .then(results => {                        
                        //console.log(results)
                        this.loaded = true;
                        this.dataLoaded = true;
                        return results;   
                        //return results.length > 0 ? results[results.length - 1] : [];
                        
                    })
                
                })
            
        },
        
        resetSearch(){
            this.filter = ''
            if( this.rows != this.storedRows && this.storedRows.length > 0 ){
               this.rows = this.storedRows
            }
        },
        
        searchInDB(){
            
            var regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
            var regexPhone = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
            
            if( this.filter ){
                
                if( this.filter.startsWith( "@" ) || this.filter.startsWith("!") || this.filter.startsWith("$") ){
                    console.log("search for tags: "+this.filter )
                    this.searchFirestore( "tags", this.filter )
                }else{
                    console.log("search for email: "+this.filter )
                    this.searchFirestore( "email", this.filter )
                }
            }
                
        },
        
        //old
        
        getSubcollectionDocs(docID){
            
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            
            let orgID =  user.organizationID;
            
            const db = firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/leads').doc(docID).collection('tags').orderBy('datetime', 'desc');
            let items = [];
            return ref.get()
                .then(snapshot => {
                    snapshot.forEach(doc => {
                        //console.log(item.data())
                        let item = {};
                        item = doc.data(); // will have 'todo_item.title' and 'todo_item.completed'             
                        item.docID = doc.id;
                        //console.log( item )
                        items.push(item);
                    })
                    return items;
                })
        },
        
        //
        
        returnName(a){
            let name = a.firstname + " " + a.lastname;
            return name;
        },
        LeadEmail(a){
            let result = a.email
            if( a.primary_lead ){
                result += ' <b class="html-circle" title="Child lead, has a primary lead attached" >&#9679</b> '
            }
            return result;
        },
        returnDate(a){
            //return this.$moment.unix(a.datetime).format( 'MMM D, HH:mm' )
            return helper.formatDate( a.datetime, 'MMM D, HH:mm' )
        },
        returnFirstSource(a){
            //GET LAST SOURCE FROM ARRAY; ORDER DESC
            let sourceTags = []
            if( a.tags_subcollection.length > 0 ){
                let r = ''
                a.tags_subcollection.map(tag =>{
                    if( tag.type == 1 ){
                        sourceTags.push( tag )
                    }
                })
                if( sourceTags.length > 0 ){
                    r = sourceTags.slice(-1)[0] 
                    r = r.tag
                }
                return r
                
            }else{
                return ''
            }
                
        },
        returnLastSource(a){
            //GET FIRST SOURCE FROM ARRAY; ORDER DESC
            let sourceTags = []
            if( a.tags_subcollection.length > 0 ){
                let r = ''
                a.tags_subcollection.map(tag =>{
                    if( tag.type == 1 ){
                        sourceTags.push( tag )
                    }
                })
                if( sourceTags.length > 0 ){
                    r = sourceTags[0]
                    r = r.tag
                }
                return r
            }else{
                return ''
            }
            //return this.$moment.unix(a.datetime).format( 'DD/MM/YYYY HH:mm' )
        },
        renderTag(field){
            if( field.tag.length > 30 ){
                return field.tag.substring(0,30) + "..."
            }else{
                return field.tag
            }
                
        },
        renderStatus(a){
            var r;
            
            if( a.Status == 1 ){
                r = 'Active';
            }else if( a.Status == 0 ){
                r = 'Inactive';
            }else if( a.Status == 2 ){
                r = 'Blocked';
            }else if( a.Status == 3 ){
                r = 'Manually blocked';
            }
            
            return r;
        },
        routeUser(params){
            
            //console.log(params)
            /*
            let id = params.row.id;
            
            this.$router.push({
                name: 'Lead',
                params: { ID: params.row.leadID }
            }); 
            */
            this.fModalOpen( params.row );
        },
        fModalOpen( data ){
            this.modalData = data
            //this.modalData.orderID = data.id
            //this.modalData.id = data.leadID
            //this.modalLeadID = data.leadID
            this.modalState = true
        },
    },
    computed:{
    },
}
</script>

<style lang="scss" >
    
     @import '@/assets/css/atlass-datatable.scss';
     @import '@/assets/css/atlass-modal.scss';
    
    .html-circle{
        font-size: 18px;
        line-height: 14px;
    }
    
</style>


// WEBPACK FOOTER //
// src/templates/leads/LeadConversions.vue